import PropTypes from 'prop-types';
import { Alert, Button, Stack, Typography } from '@mui/material';

export default function PmsSchedulingStatus({ scope }) {
    return scope.error ? <Alert severity="error" action={<Button onClick={scope.retry}>Retry</Button>}>
        {scope.denied ? 'You do not have access to native booking for this practice.' : 'Booking settings could not be loaded. Retry before starting a booking.'}
    </Alert> : <Stack sx={{ p: 2 }} role="status"><Typography>Loading booking settings…</Typography></Stack>;
}
PmsSchedulingStatus.propTypes = { scope: PropTypes.shape({ error: PropTypes.bool, denied: PropTypes.bool, retry: PropTypes.func }).isRequired };
